import { FormHelperText, useTheme } from "@mui/material";
import { FieldError } from "react-hook-form";

type RHFFieldErrorTextProps = {
  fieldError: FieldError;
};

export const RHFFieldErrorText = ({ fieldError }: RHFFieldErrorTextProps) => {
  const theme = useTheme();

  return (
    <FormHelperText sx={{ color: theme.palette.error.main }}>{fieldError?.message}</FormHelperText>
  );
};
